import React, { useEffect, useState } from 'react'
import './BurgerRain.css'
//import barbeku from '../../assets/home/rain/barbeku.png'
// Tüm görseller backend'den gelecek; lokal fallback kaldırıldı

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL as string
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY as string
const REST_BASE = `${SUPABASE_URL}/rest/v1`
const REST_HEADERS: Record<string, string> = SUPABASE_ANON_KEY
   ? { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` }
   : {}

interface Burger {
   id: number
   left: number
   animationDuration: number
   delay: number
   fontSize: string
}

// Backend verisi kullanılacak; fallback yok

type BurgerRainProps = {
   forceVisible?: boolean
   previewDay?: number // 1-31
   previewImageUrl?: string | null
}

const BurgerRain: React.FC<BurgerRainProps> = ({
   forceVisible = false,
   previewDay,
   previewImageUrl,
}) => {
   const [burgers, setBurgers] = useState<Burger[]>([])
   const [isMenuVisible, setIsMenuVisible] = useState(false)
   const [imageMap, setImageMap] = useState<Record<number, string>>({}) // day(1-31) -> url
   const [cacheBuster, setCacheBuster] = useState<number>(Date.now())
   // Bugünün gününü al (1-31)
   const today = new Date()
   const dayOfMonth = previewDay ?? today.getDate() // 1-31
   // Bugünkü görseli al
   const todayImage = (previewImageUrl ?? imageMap[dayOfMonth] ?? null) as
      | string
      | null
   const withCache = (url: string | null) => {
      if (!url) return null
      const sep = url.includes('?') ? '&' : '?'
      return `${url}${sep}v=${cacheBuster}`
   }
   const imageSrc = withCache(todayImage)

   // Ay verisini backend'den çek ve admin güncellemelerini dinle
   useEffect(() => {
      const y = today.getFullYear()
      const m = today.getMonth() + 1 // 1-12
      const load = () => {
         const start = `${y}-${String(m).padStart(2, '0')}-01`
         const endMonth = m === 12 ? 1 : m + 1
         const endYear = m === 12 ? y + 1 : y
         const end = `${endYear}-${String(endMonth).padStart(2, '0')}-01`
         fetch(
            `${REST_BASE}/rainimages?select=*&date=gte.${start}&date=lt.${end}&order=date`,
            { headers: REST_HEADERS }
         )
            .then(r => (r.ok ? r.json() : []))
            .then((list: { date: string; image_url: string }[]) => {
               const map: Record<number, string> = {}
               list.forEach(item => {
                  const m0 = item.date.match(/^(\d{4})-(\d{2})-(\d{2})/)
                  if (m0) {
                     const day = Number(m0[3])
                     if (day >= 1 && day <= 31 && item.image_url)
                        map[day] = item.image_url
                  }
               })
               setImageMap(map)
               setCacheBuster(Date.now())
            })
            .catch(() => setImageMap({}))
      }
      load()

      const onStorage = (e: StorageEvent) => {
         if (e.key === 'rainImages:updated') {
            setTimeout(load, 200)
         }
      }
      window.addEventListener('storage', onStorage)
      return () => window.removeEventListener('storage', onStorage)
   }, [])

   useEffect(() => {
      if (forceVisible) {
         setIsMenuVisible(!!todayImage)
         return
      }
      const handleScroll = () => {
         const menuSection = document.querySelector('.menu-section')
         if (menuSection) {
            const rect = menuSection.getBoundingClientRect()
            if (rect.top <= window.innerHeight) {
               setIsMenuVisible(!!todayImage)
            } else {
               setIsMenuVisible(false)
            }
         } else {
            // Menü bulunamazsa bugünkü görsel varsa yağdır
            setIsMenuVisible(!!todayImage)
         }
      }
      window.addEventListener('scroll', handleScroll)
      handleScroll()
      return () => window.removeEventListener('scroll', handleScroll)
   }, [todayImage, forceVisible])

   useEffect(() => {
      if (isMenuVisible) {
         // Create initial burgers
         const initialBurgers = Array.from({ length: 20 }, (_, index) => ({
            id: index,
            left: Math.random() * 100,
            animationDuration: 3 + Math.random() * 2,
            delay: Math.random() * 2,
            fontSize: `${12 + Math.random() * 36}px`, // Rastgele boyut (12px ile 36px arasında)
         }))
         setBurgers(initialBurgers)

         // Add new burgers periodically
         const interval = setInterval(() => {
            setBurgers(prevBurgers => {
               const newBurger = {
                  id: Date.now(),
                  left: Math.random() * 100,
                  animationDuration: 3 + Math.random() * 2,
                  delay: Math.random() * 2,
                  fontSize: `${64 + Math.random() * 82}px`,
               }
               return [...prevBurgers, newBurger].slice(-30) // Keep max 30 burgers
            })
         }, 500)

         return () => clearInterval(interval)
      } else {
         // Menü görünür değilse hamburgerleri temizle 🍔
         setBurgers([])
      }
   }, [isMenuVisible])

   return (
      <div className="burger-rain-container">
         {imageSrc &&
            burgers.map(burger => (
               <div
                  key={burger.id}
                  className="burger"
                  style={{
                     left: `${burger.left}%`,
                     animationDuration: `${burger.animationDuration}s`,
                     animationDelay: `${burger.delay}s`,
                     fontSize: burger.fontSize,
                  }}>
                  <img
                     src={imageSrc}
                     alt="Burger Rain Item"
                     style={{
                        width: burger.fontSize,
                        height: 'auto',
                     }}
                  />
               </div>
            ))}
      </div>
   )
}

export default BurgerRain
